export function dailySessionReset() {
  const today = new Date().toISOString().split('T')[0]; // e.g. "2025-10-08"
  const lastCleanup = localStorage.getItem('lastCleanupDate');

  if (lastCleanup !== today) {
    // Clear storages
    localStorage.clear();
    sessionStorage.clear();

    // Mark cleanup as done
    localStorage.setItem('lastCleanupDate', today);

    // Force full reload to ensure fresh assets (bypass cache)
    // Cache Busting Reload
    window.location.href = window.location.origin + '?t=' + Date.now();
  }
}
